import styled from 'styled-components';

// import { Row, Col, Select } from '@useblu/ocean-react';

// import {
//   spacingStackXs,
//   spacingStackMd,
//   fontFamilyHighlight,
//   colorBrandPrimaryPure,
// } from '@useblu/ocean-tokens/web/tokens';

// import { breakpointTo, breakpointFrom, bpMedium } from 'tokens';

export const Container = styled.div`
  width: 100%;
  height: 100px;
  /* background-color: #ccc; */
`;

// @media ${breakpointFrom(bpMedium)} {
//     display: none;
//   }
